import { useContext, useEffect, useState } from 'react';
import CalendarioContext from '../../context/calendarioContext';
import UserContext from '../../context/userContext';
import getRooms from '../../services/getRooms';
import { Button, Heading, Switch, Text } from '@chakra-ui/react';
import Room from './Room';
import Confirmacion from './Confirmacion';
import getOffer from '../../services/getOffers';
import Offers from './Offers';
import { diffDates } from '@fullcalendar/core/internal';
import { useNavigate } from 'react-router';
import { Loading } from '../Common/Loading';
import { filterRooms } from '../../helpers/transformCabana';
import { getPolicies } from '../../services/policies';
import { useTranslation } from 'react-i18next';

export const Reservar = () => {

  const { t } = useTranslation();

  const { user, otraCabana } = useContext(UserContext);
  const { dia, rooms, setRooms, reservationType, people, setPeople } =
    useContext(CalendarioContext);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [isDayPass, setIsDayPass] = useState(false);
  const [isCuentaPropia, setIsCuentaPropia] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const [policies, setPolicies] = useState(null);

  useEffect(() => {
    if (dia.startStr && dia.endStr) {
      setRooms(null);
      getRooms(dia.startStr, dia.endStr)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.rooms.length) {
              setRooms(null);
            } else {
              let newRooms = !otraCabana
                ? filterRooms(res.data.rooms, user.tipoCabana)
                : res.data.rooms;
              if (!newRooms.length) {
                setRooms(null);
              } else {
                setRooms(newRooms);
              }
            }
          }
        })
        .catch((err) => console.error(err))
        .finally(() => setIsLoading(false));
    }

    return () => {
      setRooms(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dia]);

  const diff = diffDates(dia.start, dia.end);

  const [selectedRoom, setSelectedRoom] = useState({});
  const [selectionSteps, setSelectionSteps] = useState({
    isRoomSelected: false,
    isOfferSelected: false,
  });
  const [offers, setOffers] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState({});
  const [bookingData, setBookingData] = useState(_bookingData);

  const handleSelectedRoom = (room) => {
    setSelectedRoom(room);
    setSelectionSteps({ ...selectionSteps, isRoomSelected: true });
  };

  const requestPolicies = async () => {
    try{
      const res = await getPolicies();
      if (res.status === 200) {
        setPolicies(res.data);
      }
    } catch (error) {
      console.error('Error fetching policies:', error);
    }
  }

  const handleSelectedOffer = (offer) => {
    setSelectedOffer(offer);
    setSelectionSteps({ ...selectionSteps, isOfferSelected: true });
    setPeople(offer.max_occupancy);
    setBookingData({
      ...bookingData,
      date_from: dia.startStr,
      date_to: dia.endStr,
      rooms: [
        {
          room_code: selectedRoom.short_code,
          offer: null,
          rate_category: offer.rate_category,
        },
      ],
      customer: {
        email: user.correo,
        first_name: user.nombre,
        last_name: user.apellidos || '',
        phone_number: user.numeroTel || '1122334455',
        address: user.direccion || 'Address',
        city: user.ciudad || 'Mexico',
        postal_code: user.cp || '03000',
        country: user.pais || 'MX',
      },
    });
  };

  const handleBack = () => {
    if (selectionSteps.isOfferSelected) {
      setSelectionSteps({ ...selectionSteps, isOfferSelected: false });
      setSelectedOffer({});
    } else {
      setSelectionSteps({ ...selectionSteps, isRoomSelected: false });
      setSelectedRoom({});
    }
  };

  const clearSelection = () => {
    setSelectedRoom({});
    setSelectionSteps({ isRoomSelected: false, isOfferSelected: false });
    setBookingData({});
    setIsDayPass(false);
    navigate('/reservar-ahora');
  };

  useEffect(() => {
    if (selectionSteps.isRoomSelected) {
      setIsLoading(true);
      getOffer(dia.startStr, dia.endStr, selectedRoom.short_code)
        .then((res) => {
          if (res.status === 200) {
            if (reservationType === 'NOCHEHOTELERA' || otraCabana) {
              const filteredOffer = res.data.offers.filter((offer) => {
                return offer.title === 'Tarifa adicionales';
              });
              setOffers(filteredOffer);
            } else {
              const filteredOffer = res.data.offers.filter((offer) => {
                return offer.title === 'Tarifa para miembros';
              });
              setOffers(filteredOffer);
            }
          }
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectionSteps.isRoomSelected]);

  useEffect(() => {
    //requestPolicies();
  }, [])

  if (isLoading) return <Loading />;

  if (!isLoading && !rooms)
    return (
      <div className="px-5 py-4 d-flex flex-column">
        <Text fontSize="lg">{t('NO_ROOMS_AVAILABLE')}</Text>
        <Button
          width="xs"
          my="5"
          colorScheme="blue"
          onClick={() => navigate('/reservar-ahora')}
        >
            {t('GO_BACK_TO_FORM')}
        </Button>
      </div>
    );

  return (
    <div className="px-5 py-2">
      <Heading my={2}>{t('RESERVE')}</Heading>
      <div className="">
        {!selectionSteps.isRoomSelected ? (
          <>
            <Heading as="h4" fontSize={['md', 'lg', 'xl']}>
              {t('SELECT_A_ROOM')}
            </Heading>
            <div
              className=""
              style={{
                overflowY: 'scroll',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '25px',
              }}
            >
              {rooms.map((room) => (
                <Room
                  key={room.short_code}
                  room={room}
                  people={people}
                  checkin={dia.startStr}
                  checkout={dia.endStr}
                  onClick={handleSelectedRoom}
                />
              ))}
            </div>
          </>
        ) : selectionSteps.isOfferSelected ? (
          <>

            <Confirmacion
              room={selectedRoom}
              date={dia}
              data={bookingData}
              clear={clearSelection}
              id={user.id}
              noches={diff.days}
              isDayPass={isDayPass}
              offer={selectedOffer}
              isCuentaPropia={isCuentaPropia}
              setIsDisabled={setIsDisabled}
            />
          </>
        ) : (
          <>
            <Heading as="h4" fontSize={['md', 'lg', 'xl']}>
              {t('SELECT_A_RATE')}
            </Heading>
            <div
              className="my-2"
              style={{
                maxHeight: '75vh',
                overflowY: 'scroll',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
                gap: '25px',
              }}
            >
              {offers.map((offer) => (
                <Offers
                  key={offer.rate_category}
                  offer={offer}
                  checkin={dia.startStr}
                  checkout={dia.endStr}
                  onClick={handleSelectedOffer}
                />
              ))}
            </div>
          </>
        )}

        <div className="mt-5">
          <Button
            colorScheme="yellow"
            my={5}
            mr={3}
            onClick={clearSelection}
            isDisabled={isDisabled}
          >
            {t('GO_BACK_TO_FORM')}
          </Button>
          {selectionSteps.isOfferSelected || selectionSteps.isRoomSelected ? (
            <Button
              mr={3}
              onClick={handleBack}
              colorScheme={'red'}
              isDisabled={isDisabled}
            >
              {t('BACK')}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const _bookingData = {
  date_from: '',
  date_to: '',
  rooms: [
    {
      room_code: '',
      offer: null,
      rate_category: null,
    },
  ],
  extras: [],
  card: {
    token: 'E67TY8GQ27X',
    provider: 'braintree',
  },
  customer: {
    email: 'titular@digitalhype.mx',
    first_name: 'Titular',
    last_name: 'Prueba',
    phone_number: '+12312332123',
    address: 'Address',
    city: 'Mexico',
    postal_code: '03000',
    country: 'GB',
  },
};
